<template>
  <div class="menuDiv">
    <v-layout justify-end align-start>
      <div class="menuButton">
        <div v-if="!this.showFilterMenu"></div>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="250"
          transition="scale-transition"
          origin="center center"
          bottom
          v-if="this.showFilterMenu"
        >
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small style="margin-bottom: -1.5em; color: black; font-size: 35px;">filter_alt</v-icon>
          </template>
          <v-card v-if="callingOnDRG">
            <v-card-title class="headline font-weight-bold">{{$translate('FILTER_OPTIONS')}}</v-card-title>
            <v-list>
              <v-list-tile v-for="(item, index) in $store.getters.getAllDelivers" :key="item.title">
                <v-list-tile-action>
                  <v-switch v-model="item.selected" :color="item.color" @change="changeTheDelivers()"></v-switch>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{$translate('DELIVERER')}} {{index + 1}}
                    <v-icon class="timeIconStyle">query_builder</v-icon>{{item.totalTime}} {{$translate('HOUR')}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
          <v-card v-else>
            <v-card-title class="headline font-weight-bold">{{$translate('FILTER_OPTIONS')}}</v-card-title>

            <v-divider></v-divider>
            <v-divider></v-divider>
            <h3 class="ml-1">{{$translate('EVENT_TOUR')}}</h3>
            <v-divider></v-divider>

            <v-list>
              <v-list-tile v-for="item in travelModes" :key="item.title">
                <v-list-tile-action>
                  <v-switch v-model="item.selected" color="purple" @change="filterTravelModes"></v-switch>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title v-text="item.title"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-divider></v-divider>
            <h3 class="ml-1">{{$translate('LOCATIONS')}}</h3>
            <v-divider></v-divider>

            <v-list>
              <v-list-tile v-for="item in userTagGroups" :key="item.title">
                <v-list-tile-action>
                  <v-switch v-model="item.selected" color="purple" @change="filterLocations"></v-switch>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title v-text="item.title"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
      </div>
    </v-layout>
<!--    <v-layout justify-end align-end>-->
<!--&lt;!&ndash;      get my activities screen&ndash;&gt;-->
<!--      <v-card-->
<!--        v-if="this.$store.getters.getMAS"-->
<!--        class="openstreetmapContributorsMAS"-->
<!--      >© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> {{$translate('CONTRIBUTORS')}}-->
<!--      </v-card>-->
<!--&lt;!&ndash;      getAcitivtyDetails screen&ndash;&gt;-->
<!--      <v-card-->
<!--        v-else-if="this.$store.getters.getADS && !$store.getters.getMobilePhoneActive"-->
<!--        class="openstreetmapContributorsADS"-->
<!--      >© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> {{$translate('CONTRIBUTORS')}}-->
<!--      </v-card>-->
<!--      <v-card-->
<!--        v-else-if="this.$store.getters.getADS && $store.getters.getMobilePhoneActive"-->
<!--        class="openstreetmapContributorsADSmobile"-->
<!--      >© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> {{$translate('CONTRIBUTORS')}}-->
<!--      </v-card>-->
<!--&lt;!&ndash;      <v-card&ndash;&gt;-->
<!--&lt;!&ndash;        v-if="this.$store.getters.getMobilePhoneActive"&ndash;&gt;-->
<!--&lt;!&ndash;        class=""&ndash;&gt;-->
<!--&lt;!&ndash;      >© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> {{$translate('CONTRIBUTORS')}}&ndash;&gt;-->
<!--&lt;!&ndash;      </v-card>&ndash;&gt;-->
<!--      <v-card-->
<!--        v-else-if="!$store.getters.getMobilePhoneActive"-->
<!--        class="openstreetmapContributors"-->
<!--      >© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> {{$translate('CONTRIBUTORS')}}-->
<!--      </v-card>-->
<!--      <v-card-->
<!--        v-else-if="$store.getters.getMobilePhoneActive"-->
<!--        class="openstreetmapContributorsMobile2"-->
<!--      >© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> {{$translate('CONTRIBUTORS')}}-->
<!--      </v-card>-->
<!--&lt;!&ndash;        <v-card&ndash;&gt;-->
<!--&lt;!&ndash;        v-if="$store.getters.getMobilePhoneActive"&ndash;&gt;-->
<!--&lt;!&ndash;        class="openstreetmapContributorsMobile2"&ndash;&gt;-->
<!--&lt;!&ndash;      >© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> {{$translate('CONTRIBUTORS')}}&ndash;&gt;-->
<!--&lt;!&ndash;      </v-card>&ndash;&gt;-->
<!--    </v-layout>-->
    <OperationalScreen_MapQuadrant class="ml-4" :properties="locationProps"></OperationalScreen_MapQuadrant>
  </div>
</template>


<script>
import { store } from "@/store.js";
import BaseObject from "@/objects/BaseObject";
import UserObject from "@/objects/UserObject";
import appConfig from "../../config/app_config";
import * as dssRequest from "@/api/dssRequest";
import { ui_helpers } from "../shared/ui_helpers";
import BaseComponent from "./base/BaseComponent.vue";
import OperationalScreen_MapQuadrant from "./OperationalScreen/OperationalScreen_MapQuadrant";
import * as ol from "openlayers";
import _ from "lodash";
import { mapGetters } from "vuex";


export default {
  name: "MapOverview",
  extends: BaseComponent,
  components: {
    OperationalScreen_MapQuadrant
  },
  props: {
    properties: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    }
  },
  mixins: [ui_helpers],
  beforeDestroy() {},
  data() {
    return {
      callingOnDRG: false,
      showFilterMenu: true,
      showThingsOnMap: true,
      menu: false,
      travelModes: [],
      userTagGroups: [
        { selected: true, title: "Activities", value: 46 },
        { selected: true, title: "Bus", value: 369 },
        { selected: true, title: "Drinking & Nightlife", value: 84 },
        { selected: true, title: "Eating", value: 59 },
        { selected: true, title: "Entertainment", value: 103 },
        { selected: true, title: "Ferry", value: 370 },
        { selected: false, title: "POI", value: 368 },
        { selected: true, title: "Shopping", value: 118 },
        { selected: true, title: "Sights", value: 18 },
        { selected: true, title: "Sleeping", value: 134 }
      ],
      allLocations: [],
      allTours: {},
      allRelays: {},
      locationProps: {
        component: "OperationalScreen_MapQuadrant",
        componentId: "OperationalScreen_MapQuadrant_MAPOFINCIDENT",
        fullSize: true,
        hidden: false,
        location: {},
        mainMap: false,
        name: "OperationalScreen_MapQuadrant_NPSTNJ",
        params: {
          location: {
            pathPoints: [],
            latitude: "",
            longitude: "",
            polyline: "",
            waypoints: ""
          },
          locations: []
        },
        pinned: true,
        position: {
          x: 0,
          y: 0
        },
        profile: {
          connect: false,
          default: false,
          landing: true,
          relink: true,
          style: {
            height: "big"
          }
        },
        height: "",
        showBackButton: true,
        showToolbar: false,
        signalObjectMap: [],
        tag: "",
        interaction: true,
        tooltip: false,
        rightClick: false,
        includeCenterPoint: false,
        clickEvent: true,
        zoomControls: true,
        mouseScrollControls: false
      }
    };
  },
  computed: {
    ...mapGetters({
      _allRoutes: "getRoutes"
    }),
  },
  watch: {
    _allRoutes: function(newV, oldV) {
      if (newV !== oldV) {

        window.EventBus.fire("generateTourPoints", {routeAspects: Object.values(newV), disableChangeView: false});
      }
    }

},
  created() {
    window.EventBus.listen("showToursAndRelays", this.showToursAndRelays);
  },
  mounted() {


    if ((this.properties.hasOwnProperty("showFilterMenu"))){
      this.showFilterMenu = this.properties.showFilterMenu;
    }
    if ((this.properties.hasOwnProperty("showThingsOnMap"))){
      this.showThingsOnMap = this.properties.showThingsOnMap;
    }
    if((this.properties.hasOwnProperty('callingOnDRG'))){
      this.callingOnDRG = this.properties.callingOnDRG;
    }

    if (this.$store.getters.getADS === true && this.$store.getters.getMobilePhoneActive === true) {

      this.height="height:45vh"
    } else {
      this.height = "height: 82vh"
    }
    if(this.properties.hasOwnProperty('zoomControls')) this.locationProps.zoomControls = this.properties.zoomControls;
    if(this.properties.hasOwnProperty('interaction')) this.locationProps.interaction = this.properties.interaction;
    if(this.properties.hasOwnProperty('clickEvent')) this.locationProps.clickEvent = this.properties.clickEvent;
    if ((this.properties.hasOwnProperty("height"))) this.locationProps.height = this.properties.height;
    if ((this.properties.hasOwnProperty("showBackButton"))) this.locationProps.showBackButton = this.properties.showBackButton;
    console.log("Lorenzo this.locationProps", this.locationProps);
    if (this.showThingsOnMap) {
      this.getTravelModes();
      this.getLocations();
    }
    this.focusMapDefault();
  },
  beforeDestroy(){
    window.EventBus.removeListener("showToursAndRelays", this.showToursAndRelays);
  },
  methods: {
    focusMapDefault() {

      let payload = {
        LocationId     : this.$store.getters.getAccountInfo.LocationId,
        StructuredReply: true,
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "- Called on Map_Overview.vue - the call for `getLocationDetails on Main location` was successful",
            response
          );
          let focusCoordinates = [Number(response.data.Longitude), Number(response.data.Latitude)];
          window.EventBus.fire("focusOnMarker", focusCoordinates);
        },

        error => {
          console.log(
            "- Called on Map_Overview.vue - the call for `getLocationDetails on Main location` was successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GLD_001');
        },
        "getLocationData",
        this.$store.getters.getAccountInfo.LocationId,
        payload,
        600000,
        false
      );
    },
    getTravelModes() {
      let payload = {};

      dssRequest.doRequest(
        response => {
          console.log(
            "The call getTransportationTypesForRelays was successful",
            response
          );

          this.travelModes = [];

          Object.entries(response.data.TransportModes).forEach(([key, value]) => {
            let travelObj = {}
            if(key === 'Public transport') travelObj = { selected: false, title: key, value: value };
            else travelObj = { selected: true, title: key, value: value };
            this.travelModes.push(travelObj);
          });
        },
        error => {
          console.log(
            "The call getTransportationTypesForRelays was not successful",
            error
          );
        },
        "getTransportationTypesForRelays",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    changeTheDelivers(){
      window.EventBus.fire("showDeliveryRoute", this.$store.getters.getAllDelivers);
      window.EventBus.fire("showDeliveryRouteMarkers", this.$store.getters.getDeliverMarkers);
    },
    getLocations() {
      // This function is used to retrieve the locations for the map
      let payload = {};
      let object = "";

      // Check if user is on partner env. or account env. to visualise the locations regarding the env.
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        payload.PartnerId = -1;
        object = this.$store.getters.getCurrentAccountId;
      } else {
        payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
        object =
          this.$store.getters.getCurrentAccountId +
          "_UG_" +
          this.$store.getters["auth/partnerId"];
      }

      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getLocations was successful",
            response
          );
            setTimeout(() => {
              if(!_.isEmpty(this.$store.getters.getLocationsOfUserTripList)){
                let selectedEvents = [];
                for(let [index, item] of Object.entries(this.$store.getters.getLocationsOfUserTripList)){

                  item.Latitude = item.StartLatitude;
                    item.Longitude = item.StartLongitude;
                    item.Id = item.StartLocationId;

                    delete item.StartLatitude;
                    delete item.StartLongitude;
                    delete item.StartLocationId;

                  if(item.Latitude != 0 && item.Longitude != 0){
                    this.allLocations = Object.keys(response.data.Locations).map(
                      key => response.data.Locations[key]
                    );
                    let visibleLocations = [...this.allLocations];
                    visibleLocations.forEach(e  => {
                      if (e.Id == item.Id) {
                        selectedEvents.push(e);
                        // window.EventBus.fire("categoriesMarkers", [e]);
                        let focusCoordinates = [Number(e.Longitude), Number(e.Latitude)];
                        window.EventBus.fire("focusOnMarker", focusCoordinates);
                      }
                    });
                  }
                }
                if (this.showThingsOnMap) {

                  window.EventBus.fire("categoriesMarkers", selectedEvents);
                }

                // if (object.Type=="End" && object.StartDate !== object.EndDate) object.Name = (object.Name + " (end) ");
                // if (object.Type =="Start") {
                //   if (!this.userActivities.includes(object.UniqueId)) {
                //     this.userActivities.push(object)
                //   }
                // } else if (object.Type =="End" && (object.StartDate !== object.EndDate)) {
                //   this.userActivities.push(object);
                // }
              }

              else if(this.$store.getters.getSelectedEventId == ''){
                this.showToursAndRelays();
                this.allLocations = Object.keys(response.data.Locations).map(
                  key => response.data.Locations[key]
                );
                let visibleLocations = [...this.allLocations];
                this.$store.commit("setAllVisibleLocations", visibleLocations);
                window.EventBus.fire("categoriesMarkers", visibleLocations);

                // Get the location with the lowest Depth as the center point of the map
                let minDepth = Infinity;
                let centerIndex = 0;
                this.allLocations.forEach((element, index) => {
                  let currDepth = Number(element.Depth);
                  if(element.Name === 'NL') return;
                  if(currDepth < minDepth) {
                    minDepth = currDepth;
                    centerIndex = index;
                  }
                });

                let focusCoordinates = [Number(this.allLocations[centerIndex].Longitude), Number(this.allLocations[centerIndex].Latitude)];
                window.EventBus.fire("focusOnMarker", focusCoordinates);
              }
              else {
                this.allLocations = Object.keys(response.data.Locations).map(
                  key => response.data.Locations[key]
                );
                let visibleLocations = [...this.allLocations];
                let selectedEvent = {};
                visibleLocations.forEach(e  => {
                  if (e.Id == this.$store.getters.getSelectedEventId) {
                    this.$store.commit("setLocationDetails", e);
                    selectedEvent = [e]
                  }
                });

                window.EventBus.fire("categoriesMarkers", selectedEvent);

                let focusCoordinates = [Number(selectedEvent[0].Longitude), Number(selectedEvent[0].Latitude)];
                window.EventBus.fire("focusOnMarker", focusCoordinates);
              }
            }, 1000);
        },
        error => {
          console.log(
            "The generic call getLocations was not successful",
            error
          );
        },
        "getLocations",
        object,
        payload
      );
    },
    showToursAndRelays(callingFromADS) {

        window.EventBus.fire("generateTourPoints", {routeAspects: Object.values(this.$store.getters.getRoutes), disableChangeView: false});
      // console.log("Lorenzo callingFromADS", callingFromADS);
      // // This function is used to retrieve the locations for the map
      // let payload = {
      //   LanguageTagId: this.$store.getters.getUserLanguage
      // };
      // let object = "";
      //
      // // Check if user is on partner env. or account env. to visualise the tours regarding the env.
      // if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
      //   payload.PartnerId = -1;
      //   object = this.$store.getters.getCurrentAccountId;
      // } else {
      //   payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      //   object =
      //     this.$store.getters.getCurrentAccountId +
      //     "_UG_" +
      //     this.$store.getters["auth/partnerId"];
      // }
      // dssRequest.doRequest(
      //   response => {
      //     console.log("The generic call showToursAndRelays was successful", response);
      //
      //     this.allTours = response.data.Tours;
      //     if(callingFromADS){
      //       this.$store.commit('setTours', this.allTours);
      //     }
      //     else {
      //       console.log("Lorenzo hier kom ik in", );
      //       window.EventBus.fire("showTours", this.allTours);
      //     }
      //   },
      //   error => {
      //     console.log("The generic call getTours was not successful", error);
      //   },
      //   "getTours",
      //   object,
      //   payload
      // );
    },
    // getRelays() {
    //   // This function is used to retrieve the locations for the map
    //   let payload = {
    //     LanguageTagId: this.$store.getters.getUserLanguage
    //   };
    //   let object = "";
    //
    //   // Check if user is on partner env. or account env. to visualise the locations regarding the env.
    //   if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
    //     payload.PartnerId = -1;
    //     object = this.$store.getters.getCurrentAccountId;
    //   } else {
    //     payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
    //     object =
    //       this.$store.getters.getCurrentAccountId +
    //       "_UG_" +
    //       this.$store.getters["auth/partnerId"];
    //   }
    //
    //   dssRequest.doRequest(
    //     response => {
    //       console.log("The generic call getRelays was successful", response);
    //       let publicTransportSelected = '';
    //       //check if the public transport for public transport == false
    //       this.travelModes.forEach(element => {
    //         if(element.Name === 'Public transport') publicTransportSelected = element.selected;
    //       })
    //       this.allRelays = response.data.Relays;
    //       let relaysWithoutPublicTransport = [];
    //
    //       //fill array without the public transport
    //       for(let [index, item] of Object.entries(this.allRelays)){
    //         console.log("Lorenzo item", item);
    //         if(item.Aspect.DataFieldTable.Stops == ''){
    //           relaysWithoutPublicTransport.push(item);
    //         }
    //       }
    //
    //       relaysWithoutPublicTransport = Object.assign({}, relaysWithoutPublicTransport);
    //
    //       console.log("Lorenzo this.allRelays", this.allRelays);
    //       if(publicTransportSelected) window.EventBus.fire("showRelays", this.allRelays);
    //       else  window.EventBus.fire("showRelays", relaysWithoutPublicTransport);
    //
    //     },
    //     error => {
    //       console.log("The generic call getRelays was not successful", error);
    //     },
    //     "getRelays",
    //     object,
    //     payload
    //   );
    // },
    filterLocations() {
      let deselectedTagGroups = [];

      this.allLocations.forEach (e => {

      })
      // Get deselected tag groups
      this.userTagGroups.forEach((item) => {
        if(!item.selected)
          deselectedTagGroups.push(item.title);

      });

      // Filter out locations with deselected tag groups
      let visibleLocations = [];
      if(deselectedTagGroups.length > 0) {

        this.allLocations.forEach((loc) => {
          if(!this.hasDeselectedTagGroups(loc, deselectedTagGroups)) {

            visibleLocations.push(loc);
          };
        });
      } else {
        visibleLocations = [...this.allLocations];
      }
      window.EventBus.fire("categoriesMarkers", visibleLocations);
    },
    hasDeselectedTagGroups(loc, deselectedTagGroups) {
      // Check if the location contains the tag group that is deselected
      for(let [key, value] of Object.entries(loc.LocationTags)) {
        if(deselectedTagGroups.includes(key)) {
          return true;
        }
      }
      return false;
    },
    filterTravelModes() {
      let deselectedTravelModes = [];

      // Get deselected travel modes
      this.travelModes.forEach((item) => {
        if(!item.selected)
          deselectedTravelModes.push(item.value);
      });

      // Filter out tours and relays with deselected travel modes
      // let visibleTours = {};
      // let visibleRelays = {};
      window.EventBus.fire("generateTourPoints", {routeAspects: Object.values(this.$store.getters.getRoutes), disableChangeView: false})
      // if(deselectedTravelModes.length > 0) {
      //   console.log("Brian Object.values(this.$store.getters.getRoutes)", Object.values(this.$store.getters.getRoutes));
      //
      //   Object.values(this.$store.getters.getRoutes).forEach(([key, value]) => {
      //
      //   })
      // }
      // OLD WAY

      //   Object.entries(this.allTours).forEach(([key, value]) => {
      //     if(!this.hasDeselectedTravelModes(value.Activities, deselectedTravelModes)) {
      //       visibleTours[key] = value;
      //     }
      //   });
      //
      //   Object.entries(this.allRelays).forEach(([key, value]) => {
      //     if(!deselectedTravelModes.includes(Number(value.Aspect.DataFieldTable.TravelMode))) {
      //       console.log("Lorenzo value", value);
      //       visibleRelays[key] = value;
      //     }
      //   });
      // } else {
      //   visibleTours = Object.assign({}, this.allTours);
      //   visibleRelays = Object.assign({}, this.allRelays);
      // }
      // console.log("Lorenzo visibleRelays", visibleRelays);
      // window.EventBus.fire("showTours", visibleTours);
      // window.EventBus.fire("showRelays", visibleRelays);
    },
    // hasDeselectedTravelModes(activities, deselectedTravelModes) {
    //   // Check if the tour contains the travel mode that is deselected
    //   for(let [key, value] of Object.entries(activities)) {
    //     if(value.Type === "Relay") {
    //       if(deselectedTravelModes.includes(Number(value.Aspect.DataFieldTable.TravelMode))) {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // }
  }
};
</script>

<style scoped>
.menuButton {
  z-index: 99;
  margin-right: 4em !important;
}
  .openstreetmapContributors {
    margin-right: 1em;
    margin-bottom: calc(-45%) !important;
    z-index: 4;
  }
  .openstreetmapContributorsMobile2 {
    margin-left: -2em;
    bottom: 5%;
    padding: 0;
    z-index: 4;
    position: absolute;
  }
  .openstreetmapContributorsADSmobile {
    margin-left: -2em;
    bottom: 7%;
    padding: 0;
    z-index: 4;
    text-align: center;
    width: 50%;
    position: absolute;
  }
  .openstreetmapContributorsADS {
    margin-right: 2em;
    margin-bottom: calc(-48%) !important;
    z-index: 4;
  }
  .openstreetmapContributorsMAS {
    margin-bottom: calc(-35vh) !important;
  }
  .timeIconStyle {
    margin-bottom: -0.1em; margin-left: 1em;
  }
</style>
